import { type CoreProduct, type CoreProductAvailability } from '@flecto/types'
import { deepClone } from '@flecto/utils'

import { type ProductWithAvailability } from '../types/ProductWithAvailability'

type UseStoreProductAvailabilityMergeOptions = {
  product?: CoreProduct
  productAvailability?: CoreProductAvailability
  quantityToAdd?: number
  startAt?: string
  endAt?: string
}

export function useStoreProductAvailabilityMerge({
  product,
  productAvailability,
  quantityToAdd,
  startAt,
  endAt,
}: UseStoreProductAvailabilityMergeOptions) {
  const quantityAvailable = productAvailability?.remaining_quantity ?? 0

  const suggestedPrice =
    productAvailability?.suggested_booking_cost_with_vat_cents ?? 0
  const availabilityLabel =
    !startAt || !endAt
      ? 'text_product_availability.label_available_select_dates'
      : quantityAvailable >= (quantityToAdd ?? 1)
        ? 'text_product_availability.label_available'
        : 'text_product_availability.label_available_upon_request'
  return {
    ...deepClone(product),
    quantityAvailable,
    suggestedPrice,
    availabilityLabel,
  } as ProductWithAvailability
}
